import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

import CommonImage from './CommonImage';
import { ICON_NAVIGATE_BACK } from 'assets/icons';
import Row from './Row';
import Text from './Text';
import CommonFilter from './CommonFilter';
import { HEADER_HEIGHT } from 'constants/style';
const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  position: sticky;

  top: ${props => (props.$isMobile ? '0' : `${HEADER_HEIGHT}px`)};
  padding: ${props => (props.$isMobile ? '24px 20px' : '32px 40px')};

  width: 100%;
  height: ${props => (props.$isMobile ? '84px' : '100px')};

  background-color: #fff;
  z-index: 10;
`;

interface Props {
  isMobile: boolean;
  title: string;
  path?: string;
  isAcceptFilter?: boolean;
  isShowFilter?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const ContentsTopBar: FC<Props> = props => {
  const {
    isMobile,
    title,
    path,
    isAcceptFilter,
    isShowFilter,
    style,
    onClick,
  } = props;

  const navigate = useNavigate();

  const handleNavigateBack = () => {
    if (path) {
      navigate(path);
      return;
    }

    navigate(-1);
  };

  return (
    <Container $isMobile={isMobile} style={{ ...style }}>
      <Row gap="18px">
        <CommonImage src={ICON_NAVIGATE_BACK} onClick={handleNavigateBack} />
        <Text color="#1b1c1e" size="24px">
          {title}
        </Text>
      </Row>
      {isShowFilter && (
        <CommonFilter isAcceptFilter={isAcceptFilter} onClick={onClick} />
      )}
    </Container>
  );
};

export default ContentsTopBar;
